<!-- Politique de confidentialité — structure + design (contenu à compléter) -->
<template>
    <div class="legal-page">
        <AppHead />

        <main class="legal-page__main">
            <div class="legal-page__hero">
                <div class="legal-page__hero-inner container">
                    <h1 class="legal-page__title">Politique de confidentialité</h1>
                </div>
            </div>

            <div class="legal-page__body container">
                <aside class="legal-page__toc" aria-label="Sommaire">
                    <p class="legal-page__toc-title">Sommaire</p>
                    <nav class="legal-page__toc-nav">
                        <!-- Remplacez les ancres par vos sections réelles -->
                        <a href="#section-1">1. Préambule</a>
                        <a href="#section-2">2. Responsable du traitement</a>
                        <a href="#section-3">3. Données personnelles collectées</a>
                        <a href="#section-4">4. Finalités du traitement</a>
                        <a href="#section-5">5. Base légale du traitement</a>
                        <a href="#section-6">6. Accès aux données</a>
                        <a href="#section-7">7. Sous-traitance et prestataires techniques</a>
                        <a href="#section-8">8. Sécurité des données</a>
                        <a href="#section-9">9. Durée de conservation</a>
                        <a href="#section-10">10. Droits des utilisateurs</a>
                        <a href="#section-11">11. Responsabilité de l’utilisateur</a>
                        <a href="#section-12">12. Modification de la politique de confidentialité</a>
                        <a href="#section-13">13. Droit applicable</a>
                    </nav>
                    <router-link class="legal-page__toc-alt" to="/conditions-generales-utilisation">
                        Conditions générales d’utilisation →
                    </router-link>
                </aside>

                <article class="legal-page__content">
                    <section class="legal-block" id="intro">
                        <h2 class="legal-block__title">Préambule</h2>
                        <div class="legal-block__body">
                            <p>
                                La présente politique de confidentialité a pour objet d’informer les utilisateurs de
                                l’application
                                PATRIMONEA de la manière dont leurs données personnelles, financières et patrimoniales
                                sont collectées, utilisées, protégées et conservées par patrimonea by Gwem.<br><br>
                                patrimonea by Gwem accorde une importance primordiale à la confidentialité et à la
                                sécurité des données confiées par ses clients, en particulier compte tenu de la
                                sensibilité des
                                informations patrimoniales traitées dans le cadre du service de PATRIMONEA </p>
                        </div>
                    </section>

                    <section class="legal-block" id="section-2">
                        <h2 class="legal-block__title">2. Responsable du traitement</h2>
                        <div class="legal-block__body">
                            <p>Le responsable du traitement des données est : patrimonea by Gwem.</p>
                        </div>
                    </section>

                    <section class="legal-block" id="section-3">
                        <h2 class="legal-block__title">3. Données personnelles collectées</h2>
                        <div class="legal-block__body">
                            <p>Dans le cadre de l’utilisation de l’application PATRIMONEA, patrimonea by Gwem
                                est susceptible de collecter les catégories de données suivantes :</p>
                        </div>
                    </section>

                    <section class="legal-block" id="section-4">
                        <h2 class="legal-block__title">4. Finalités du traitement</h2>
                        <div class="legal-block__body">
                            <p>Les données collectées sont traitées exclusivement pour les finalités suivantes :
                            <ul>
                                <li>• Réalisation d’analyses patrimoniales personnalisées</li>
                                <li>• Formulation de recommandations adaptées à la situation du client</li>
                                <li>• Suivi de l’évolution patrimoniale</li>
                                <li>• Respect des obligations légales et réglementaires</li>
                                <li>• Sécurisation et amélioration de l’application PATRIMONEA</li>
                            </ul>
                            Aucune donnée n’est utilisée à des fins commerciales non liées au service, ni cédée à des
                            tiers
                            à des fins de prospection.</p>
                        </div>
                    </section>

                    <section class="legal-block" id="section-5">
                        <h2 class="legal-block__title">5. Bases légales du traitement</h2>
                        <div class="legal-block__body">
                            <p>Les traitements mis en oeuvre reposent sur :
                            <ul>
                                <li>• L’exécution du contrat de souscription au service PATRIMONEA ;</li>
                                <li>• Le consentement explicite du client lors de la création de son compte ;</li>
                                <li>• Le respect des obligations légales et réglementaires applicables à PATRIMONEA By
                                    GWEM.</li>
                            </ul>
                            </p>
                        </div>
                    </section>

                    <section class="legal-block" id="section-6">
                        <h2 class="legal-block__title">6. Accès aux données</h2>
                        <div class="legal-block__body">
                            <p>Les données personnelles sont accessibles uniquement :
                            <ul>
                                <li>• Aux collaborateurs habilités de patrimonea by Gwem ;</li>
                                <li>• Dans la stricte limite de leurs fonctions ;</li>
                                <li>• Dans le respect d’une obligation renforcée de confidentialité.</li>
                                <li>• Par les autorités règlementairement compétentes le cas échéant</li>
                            </ul>
                            Les données ne sont en aucun cas vendues, louées ou communiquées à des tiers non autorisés.
                            </p>
                        </div>
                    </section>

                    <section class="legal-block" id="section-7">
                        <h2 class="legal-block__title">7. Sous-traitance et prestataires techniques</h2>
                        <div class="legal-block__body">
                            <p>patrimonea by Gwem peut recourir à des prestataires techniques (hébergement,
                                maintenance, sécurité informatique) agissant en qualité de sous-traitants. <br>
                                Ces prestataires sont contractuellement tenus :
                            <ul>
                                <li>• À une obligation stricte de confidentialité ;</li>
                                <li>• À des mesures de sécurité équivalentes à celles de patrimonea by Gwem ;</li>
                                <li>• À n’utiliser les données que sur instruction de patrimonea by Gwem.</li>
                            </ul>
                            </p>
                        </div>
                    </section>

                    <section class="legal-block" id="section-8">
                        <h2 class="legal-block__title">8. Sécurité des données</h2>
                        <div class="legal-block__body">
                            <p>patrimonea by Gwem met en oeuvre des mesures techniques et organisationnelles
                                appropriées afin de garantir :
                            <ul>
                                <li>• La confidentialité des données ;</li>
                                <li>• Leur intégrité ;</li>
                                <li>• Leur disponibilité ;</li>
                                <li>• La protection contre tout accès non autorisé, perte ou divulgation.</li>
                            </ul>
                            Ces mesures incluent notamment des contrôles d’accès, des protocoles de sécurité
                            informatique
                            et des procédures internes de gestion des données. </p>
                        </div>
                    </section>

                    <section class="legal-block" id="section-9">
                        <h2 class="legal-block__title">9. Durée de conservation</h2>
                        <div class="legal-block__body">
                            <p>Les données personnelles sont conservées pendant la durée strictement nécessaire aux
                                finalités
                                pour lesquelles elles ont été collectées, et conformément aux obligations légales
                                applicables.<br>
                                À l’issue de cette période, elles sont supprimées ou anonymisées sauf obligation légale
                                ou
                                nécessité de preuve.</p>
                        </div>
                    </section>

                    <section class="legal-block" id="section-10">
                        <h2 class="legal-block__title">10. Droits des utilisateurs</h2>
                        <div class="legal-block__body">
                            <p>Conformément à la réglementation applicable, l’utilisateur dispose des droits suivants :
                            <ul>
                                <li>• Le droit d’accès aux données ;</li>
                                <li>• Le droit de rectification ;</li>
                                <li>• Le droit de suppression ;</li>
                                <li>• Le droit de limitation du traitement ;</li>
                                <li>• Le droit d'opposition pour motifs légitimes ;</li>
                            </ul>Toute demande peut être adressée à patrimonea by Gwem par voie électronique ou
                            écrite.</p>
                        </div>
                    </section>

                    <section class="legal-block" id="section-11">
                        <h2 class="legal-block__title">11. Droits des utilisateurs</h2>
                        <div class="legal-block__body">
                            <p>L’utilisateur s’engage à :
                            <ul>
                                <li>• Fournir des données exactes, complètes et à jour ;</li>
                                <li>• Protéger la confidentialité de ses identifiants ;</li>
                                <li>• Ne pas transmettre ses accès à des tiers.</li>
                            </ul>
                            </p>
                        </div>
                    </section>

                    <section class="legal-block" id="section-12">
                        <h2 class="legal-block__title">12. Modification de la politique de confidentialité</h2>
                        <div class="legal-block__body">
                            <p>patrimonea by Gwem se réserve le droit de modifier la présente politique de
                                confidentialité afin de l’adapter aux évolutions légales, réglementaires ou
                                techniques.<br>
                                Les utilisateurs seront informés de toute modification substantielle. </p>
                        </div>
                    </section>

                    <section class="legal-block" id="section-13">
                        <h2 class="legal-block__title">13. Droit applicable</h2>
                        <div class="legal-block__body">
                            <p>La présente politique de confidentialité est soumise au droit ivoirien et aux textes
                                applicables
                                en matière de protection des données personnelles.</p>
                        </div>
                    </section>



                    <footer class="legal-page__foot">
                        <router-link to="/" class="legal-page__back">← Retour à l’accueil</router-link>
                    </footer>
                </article>
            </div>
        </main>

        <Footer />
    </div>
</template>

<script>
import AppHead from '@/components/public/AppHead.vue';
import Footer from '@/components/public/Footer.vue';

export default {
    name: 'ConfPage',
    components: { AppHead, Footer },
};
</script>

<style scoped>
.legal-page {
    min-height: 100vh;
    background:
        radial-gradient(ellipse at 88% 0%, rgba(201, 162, 39, 0.09), transparent 46%),
        linear-gradient(180deg, #f7f5f0 0%, #fff 36%);
    color: var(--brand-navy, #01263e);
    font-family: var(--font-body, Georgia, 'Times New Roman', serif);
}

.legal-page__main {
    padding-bottom: 4rem;
}

.legal-page__hero {
    padding: clamp(2.5rem, 6vw, 4rem) 0 clamp(1.75rem, 4vw, 2.5rem);
    border-bottom: 1px solid rgba(1, 38, 62, 0.08);
}

.legal-page__hero-inner {
    max-width: 920px;
}

.legal-page__eyebrow {
    margin: 0 0 0.45rem;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--brand-brown, #8a6a1a);
}

.legal-page__title {
    margin: 0 0 0.65rem;
    font-family: var(--font-display, Georgia, serif);
    font-size: clamp(1.75rem, 4vw, 2.45rem);
    font-weight: 600;
    line-height: 1.2;
    color: var(--brand-navy, #01263e);
}

.legal-page__lead {
    margin: 0 0 0.85rem;
    max-width: 38rem;
    font-size: 1.05rem;
    line-height: 1.55;
    color: var(--brand-brown-light, #5c4a3a);
}

.legal-page__meta {
    margin: 0;
    font-size: 0.85rem;
    color: rgba(1, 38, 62, 0.55);
}

.legal-page__body {
    display: grid;
    grid-template-columns: minmax(0, 220px) minmax(0, 1fr);
    gap: clamp(1.5rem, 4vw, 2.75rem);
    max-width: 960px;
    padding-top: clamp(1.75rem, 4vw, 2.75rem);
}

.legal-page__toc {
    position: sticky;
    top: 5.5rem;
    align-self: start;
    padding: 1rem 1.1rem;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.72);
    border: 1px solid rgba(1, 38, 62, 0.08);
    box-shadow: 0 10px 28px rgba(1, 38, 62, 0.04);
}

.legal-page__toc-title {
    margin: 0 0 0.65rem;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(1, 38, 62, 0.55);
}

.legal-page__toc-nav {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
}

.legal-page__toc-nav a {
    color: var(--brand-navy, #01263e);
    text-decoration: none;
    font-size: 0.9rem;
    line-height: 1.35;
    font-weight: 600;
}

.legal-page__toc-nav a:hover {
    color: var(--brand-gold, #c9a227);
}

.legal-page__toc-alt {
    display: inline-block;
    margin-top: 1rem;
    padding-top: 0.85rem;
    border-top: 1px solid rgba(1, 38, 62, 0.08);
    font-size: 0.88rem;
    font-weight: 700;
    color: var(--brand-navy, #01263e);
    text-decoration: underline;
}

.legal-page__content {
    min-width: 0;
    background: #fff;
    border: 1px solid rgba(1, 38, 62, 0.08);
    border-radius: 18px;
    padding: clamp(1.35rem, 3vw, 2rem);
    box-shadow: 0 14px 40px rgba(1, 38, 62, 0.05);
}

.legal-block+.legal-block {
    margin-top: 1.75rem;
    padding-top: 1.75rem;
    border-top: 1px solid rgba(1, 38, 62, 0.08);
}

.legal-block__title {
    margin: 0 0 0.75rem;
    font-family: var(--font-display, Georgia, serif);
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--brand-navy, #01263e);
}

.legal-block__body {
    font-size: 0.98rem;
    line-height: 1.65;
    color: rgba(1, 38, 62, 0.92);
}

.legal-block__body :deep(p) {
    margin: 0 0 0.85rem;
}

.legal-block__body :deep(ul),
.legal-block__body :deep(ol) {
    margin: 0 0 0.85rem;
    padding-left: 1.2rem;
}

.legal-block__body :deep(a) {
    color: var(--brand-navy, #01263e);
    font-weight: 700;
}

.legal-page__foot {
    margin-top: 2.25rem;
    padding-top: 1.25rem;
    border-top: 1px solid rgba(1, 38, 62, 0.08);
}

.legal-page__back {
    font-weight: 700;
    color: var(--brand-navy, #01263e);
    text-decoration: none;
}

.legal-page__back:hover {
    color: var(--brand-gold, #c9a227);
}

@media (max-width: 860px) {
    .legal-page__body {
        grid-template-columns: 1fr;
    }

    .legal-page__toc {
        position: static;
    }
}
</style>
